import { render, staticRenderFns } from "./OperationsAjustementTab.vue?vue&type=template&id=4e87f763"
import script from "./OperationsAjustementTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsAjustementTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OperationsAjustementTab.vue?vue&type=style&index=0&id=4e87f763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports